import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=7e0ba02f&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e0ba02f')) {
      api.createRecord('7e0ba02f', component.options)
    } else {
      api.reload('7e0ba02f', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=7e0ba02f&", function () {
      api.rerender('7e0ba02f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jQNTfySIo8wJ/JS/comp/childrenage.vue"
export default component.exports